import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(private router: Router) { }

  ngOnInit() {

    this.router.events.subscribe((event: any) => {
      if(event['url'] && event['url'] == '/chart') {
        (<HTMLElement>(
            document.getElementById('chartnav')
          )).style.marginLeft = '-17px';
       
      }
     });
  }

 

}
